import {  t  } from "@/client/libs/dummy-i18n";
import { cn } from "@stackmorph/utils";

type Props = {
  className?: string;
};

export const Copyright = ({ className }: Props) => (
  <div
    className={cn(
      "prose prose-sm prose-zinc flex max-w-none flex-col gap-y-1 text-xs opacity-40 dark:prose-invert",
      className,
    )}
  >
    <span>
      © {new Date().getFullYear()} Stackmorph. All rights reserved.
    </span>

    <span className="mt-4">
      {t`Stackmorph Resume Builder`} {"v" + appVersion}
    </span>
  </div>
);
